import { ComponentStyleConfig } from "@chakra-ui/react";

import { HeadingVariants } from "../variants";

const { largeXl, largeLg, largeMd, largeSm, largeXs, smallLg, smallLgSemi, smallMd, smallSm } = HeadingVariants;

export const Heading: ComponentStyleConfig = {
  variants: {
    [largeXl]: {
      fontSize: "5xl",
      fontWeight: "bold",
      lineHeight: "md",
    },
    [largeLg]: {
      fontSize: "3.5xl",
      fontWeight: "bold",
      lineHeight: "sm",
    },
    [largeMd]: {
      fontSize: "3xl",
      fontWeight: "bold",
      lineHeight: "sm",
    },
    [largeSm]: {
      fontSize: "2xl",
      fontWeight: "semibold",
      lineHeight: "sm",
    },
    [largeXs]: {
      fontSize: "lg",
      fontWeight: "medium",
      lineHeight: "sm",
    },
    [smallLg]: {
      fontSize: "xl",
      fontWeight: "bold",
      lineHeight: "md",
    },
    [smallLgSemi]: {
      fontSize: "xl",
      fontWeight: "semibold",
      lineHeight: "md",
    },
    [smallMd]: {
      fontSize: "lg",
      fontWeight: "semibold",
      lineHeight: "md",
    },
    [smallSm]: {
      fontSize: "md",
      fontWeight: "medium",
      lineHeight: "sm",
    },
  },
  defaultProps: {
    variant: largeSm,
  },
};
